import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormArray, ValidationErrors } from '@angular/forms';
import { Observer, Observable } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { formatDate } from '@angular/common';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { PopupInfoComponent } from '../popup-info/popup-info.component';
import { NzFormatEmitEvent, NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class Popup7Component implements OnInit {
  @ViewChild('tab') inputEl: ElementRef;
  validateForm: FormGroup;
  inputValue?: string;
  filteredOptions: string[] = [];

  listOfOption: Array<{ label: string; value: string }> = [];
  listOfTagOptions = [];

  listOfOption1 = ['Apples', 'Nails', 'Bananas', 'Helicopters'];
  listOfSelectedValue: string[] = [];

  options = ['Burns Bay Road', 'Downing Street', 'Wall Street'];
  constructor(private fb: FormBuilder,
    private modal: NzModalRef,
    private modalService: NzModalService,
    private notification: NzNotificationService,) {
    this.validateForm = this.fb.group({
      userName: ['', [Validators.required], [this.userNameAsyncValidator]],
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]],
      confirm: ['', [this.confirmValidator]],
      comment: ['', [Validators.required]],
      datePickerTime: ['', [Validators.required]],
    });
    this.filteredOptions = this.options;

  }
  userNameAsyncValidator = (control: FormControl) =>
    new Observable((observer: Observer<ValidationErrors | null>) => {
      setTimeout(() => {
        if (control.value === 'JasonWood') {
          // you have to return `{error: true}` to mark it as an error event
          observer.next({ error: true, duplicated: true });
        } else {
          observer.next(null);
        }
        observer.complete();
      }, 1000);
    });
  ngOnInit(): void {
    const children: Array<{ label: string; value: string }> = [];
    for (let i = 10; i < 36; i++) {
      children.push({ label: i.toString(36) + i, value: i.toString(36) + i });
    }
    this.listOfOption = children;
  }
  onChange(value: string): void {
    this.filteredOptions = this.options.filter(option => option.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
  submitForm(value: { userName: string; email: string; password: string; confirm: string; comment: string }): void {
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    this.notification.blank('Thêm người dùng thành công', 'Người dùng đã được thêm vào hệ thống!').onClick.subscribe(() => {
    });
  }
  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  isNotSelected(value: string): boolean {
    return this.listOfSelectedValue.indexOf(value) === -1;
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }
  showPopup(): void {
    this.modalService.create({
      nzTitle: 'Danh sách học sinh',
      nzContent: PopupInfoComponent,
      nzMaskClosable: false,
      nzBodyStyle: { overflow: 'scroll', height: '800px', 'overflow-x': 'hidden' },
      nzWidth: 1500,
    });
  }


}

